module.exports = __webpack_public_path__ + "img/sierraleone.33463b16.svg";